import store from "../store";
import formatDateClient from "./format-date-client";
import i18n from "../services/i18n.service";

export default {
  name: "payoutVerbiage",
  fn: (promotionProductPayout, promotionCurrency) => {
    let verbiage = "";

    // Dates
    if (promotionProductPayout?.effectiveDate && promotionProductPayout?.expirationDate) {
      verbiage +=
        i18n.translate("Between") +
        " " +
        formatDateClient.fn(promotionProductPayout.effectiveDate, "MM/DD/YYYY", store.getters.selectedClient) +
        " " +
        i18n.translate("and") +
        " " +
        formatDateClient.fn(promotionProductPayout.expirationDate, "MM/DD/YYYY", store.getters.selectedClient) +
        " ";
    } else if (promotionProductPayout?.effectiveDate) {
      verbiage +=
        i18n.translate("Starting on") +
        " " +
        formatDateClient.fn(promotionProductPayout.effectiveDate, "MM/DD/YYYY", store.getters.selectedClient) +
        " ";
    } else if (promotionProductPayout?.expirationDate) {
      verbiage +=
        i18n.translate("Ending on") +
        " " +
        formatDateClient.fn(promotionProductPayout.expirationDate, "MM/DD/YYYY", store.getters.selectedClient) +
        " ";
    }

    let productKey = undefined;
    if (promotionProductPayout?.payoutStoreCatalogProduct) {
      productKey = promotionProductPayout.payoutStoreCatalogProduct.storeProduct.productNumber;
    }

    // payout
    if (promotionProductPayout?.payoutType) {
      switch (promotionProductPayout.payoutType.name) {
        case "PERCENT_CLAIM_PRODUCT_PRICE_AMOUNT_CLAIMED":
          verbiage +=
            i18n.translate("Payout") +
            " " +
            (promotionProductPayout.payoutAmount ? promotionProductPayout.payoutAmount : "...") +
            "% " +
            i18n.translate("of product price amount");
          break;
        case "PERCENT_CLAIM_AMOUNT_CLAIMED":
          verbiage +=
            i18n.translate("Payout") +
            " " +
            (promotionProductPayout.payoutAmount ? promotionProductPayout.payoutAmount : "...") +
            "% " +
            i18n.translate("of claim invoice amount");
          break;
        case "PERCENT_PRODUCT_AMOUNT_CLAIMED":
          verbiage +=
            i18n.translate("Payout") +
            " " +
            (promotionProductPayout.payoutAmount ? promotionProductPayout.payoutAmount : "...") +
            "% " +
            i18n.translate("of product amount");
          break;
        case "FLAT_AMOUNT_PER_UNIT_CLAIMED":
          verbiage +=
            i18n.translate("Payout") +
            " " +
            (promotionProductPayout.payoutAmount ? promotionProductPayout.payoutAmount : "...") +
            (promotionCurrency ? " " + promotionCurrency : "") +
            " " +
            i18n.translate("for each product");
          break;
        case "PRODUCT":
          verbiage +=
            i18n.translate("Payout") +
            " " +
            (promotionProductPayout.payoutProductQuantity == 1
              ? promotionProductPayout.payoutProductQuantity + " " + i18n.translate("product")
              : promotionProductPayout.payoutProductQuantity + " " + i18n.translate("products")) +
            " " +
            (productKey ? "(" + productKey + ")" : "(...)");

          switch (promotionProductPayout.payoutProductMethodType.name) {
            case "EACH":
              verbiage += " " + i18n.translate("for each unit");
              break;
            case "EVERY_THRESHOLD":
              verbiage +=
                " " +
                i18n.translate("for every") +
                " " +
                promotionProductPayout.payoutProductThreshold +
                " " +
                (promotionProductPayout.payoutProductThreshold == 1
                  ? i18n.translate("unit")
                  : i18n.translate("units")) +
                " " +
                i18n.translate("claimed");
              break;
            case "FIRST_THRESHOLD":
              verbiage +=
                " " +
                i18n.translate("after the first") +
                " " +
                promotionProductPayout.payoutProductThreshold +
                " " +
                (promotionProductPayout.payoutProductThreshold == 1
                  ? i18n.translate("unit")
                  : i18n.translate("units")) +
                " " +
                i18n.translate("claimed");
              break;
            default:
          }
          break;
        case "COUPON_CODE":
          verbiage +=
            i18n.translate("Payout") +
            " " +
            (promotionProductPayout.payoutProductQuantity == 1
              ? promotionProductPayout.payoutProductQuantity + " " + i18n.translate("coupon")
              : promotionProductPayout.payoutProductQuantity + " " + i18n.translate("coupons"));

          switch (promotionProductPayout.payoutProductMethodType.name) {
            case "EACH":
              verbiage += " " + i18n.translate("for each unit claimed");
              break;
            case "EVERY_THRESHOLD":
              verbiage +=
                " " +
                i18n.translate("for every") +
                " " +
                promotionProductPayout.payoutProductThreshold +
                " " +
                (promotionProductPayout.payoutProductThreshold == 1
                  ? i18n.translate("unit")
                  : i18n.translate("units")) +
                " " +
                i18n.translate("claimed");
              break;
            case "FIRST_THRESHOLD":
              verbiage +=
                " " +
                i18n.translate("after the first") +
                " " +
                promotionProductPayout.payoutProductThreshold +
                " " +
                (promotionProductPayout.payoutProductThreshold == 1
                  ? i18n.translate("unit")
                  : i18n.translate("units")) +
                " " +
                i18n.translate("claimed");
              break;
            default:
          }
          break;
        default:
          verbiage += i18n.translate("Payout") + " " + promotionProductPayout.payoutType.description;
      }
    }
    return verbiage;
  }
};
